import {apiCall} from '@/api-transport/client';
import {STALE_TIME, GC_TIME} from '@/api-transport/constants';

export type PasskeyStatusDTO = {
  has_passkey: boolean;
};

export type BackofficeUserDTO = {
  first_name: string;
  last_name: string;
  email_address: string;
  permissions: string[];
  passkey_status: PasskeyStatusDTO;
};

export const userProfileEndpoint = {
  queryKey: ['userProfile'] as const,
  queryFn: (): Promise<BackofficeUserDTO | null> =>
    apiCall<BackofficeUserDTO | null>('/private/bootstrap', {}),
  staleTime: STALE_TIME,
  gcTime: GC_TIME,
  retry: false,
};

export const authEndpoint = userProfileEndpoint;
